// extracted by mini-css-extract-plugin
module.exports = {"social":"social__PJAR1","network":"network__3nynA"};